import { PageContentBlock } from 'app/blocks'
import { CollectionCardProps } from 'app/components/collection/CollectionCard'
import {
  CollectionType,
  createCollectionFragment,
  upperCaseFirstLetter,
} from 'app/queries/collections/collection-fragment'
import { gql } from 'graphql-request'

import { defaultsQuery } from '../globals/defaults'
import { contentFragments } from 'app/queries/content/all-content-list'
import {
  contentListQueryToContentList,
  mapContentPagination,
  PaginationWithFeatured,
} from 'app/queries/content/content-list'

export interface CollectionProps extends CollectionCardProps {
  id: string
  subtitle?: string
  content: PageContentBlock[]
  maxFeaturedPosts?: number
}

export interface PaginatedCollection extends PaginationWithFeatured {
  collection: CollectionProps
}

export const typeToName = (type: CollectionType) => {
  if (type === 'MemberTier') {
    return `contentTier`
  }

  return type.toLowerCase()
}

export const createCollectionQuery = (type: CollectionType = 'Collection') => {
  const collectionQuery = gql`
    ${createCollectionFragment(type, true)}
    ${contentFragments}
    query getCollection($collection: String, $contentTier: String, $tag: String, $page: Int, $limit: Int) {
      contentList (
        collection: $collection
        contentTier: $contentTier
        tag: $tag

        page: $page
        limit: $limit
      ) {
        totalDocs
        page
        docs {
          ...content
        }
        featured {
          ...content
        }
        ${typeToName(type)} {
          ...collection
        }
      }
      ${defaultsQuery}
    }
  `
  const mapToPage = (data: any): PaginatedCollection => {
    const collection = data.contentList[typeToName(type)]
    const defaults = data.Defaults
    const content = collection.pageContent || []
    const featuredBlock = content.find(
      (block: any) => block.__typename === 'Featured'
    )
    const props: CollectionProps = {
      id: collection.id,
      image:
        collection.thumbnail?.sizes?.thumbnail?.url ||
        defaults.thumbnail.sizes.thumbnail.url,
      title: collection.name,
      href: `/${type}/${collection.slug}`,
      itemCount: collection.itemCount || 0,
      type: type === 'Collection' ? 'playlist' : 'collection',
      subtitle: collection.subtitle || '',
      content,
      maxFeaturedPosts: featuredBlock?.maxPosts || 0,
    }

    return {
      ...mapContentPagination(data.contentList, data),
      collection: props,
    }
  }

  return {
    query: collectionQuery,
    mapToPage,
  }
}
